import { useCallbackStore } from "../callback.store";

const MAX_CALLBACK_COUNT = 10;
export function useCallbackState() {
    return useCallbackStore((state) => state.callbackState);
}

export function useCallbacksRemaining() {
    const callbacksCount = useCallbackStore((state) => state.callbackState?.callbackCount) ?? 0;

    return {
        canCallback: callbacksCount < MAX_CALLBACK_COUNT,
        callbacksRemaining: MAX_CALLBACK_COUNT - callbacksCount,
    };
}

export function getCallbackState() {
    return useCallbackStore.getState().callbackState;
}

export function hasPendingCallback() {
    return useCallbackStore.getState().callbackState?.callbackType === "CallbackNow";
}
